import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
`;

export const ClinicSection = styled.div`
  width: 80%;
  padding: 45px 50px 0px 55px;
  overflow-y: auto;
  height: 100vh;
  @media only screen and (min-width: 1600px) {
    width: 1300px;
    padding: 45px 16px 0px 0px;
    margin: 0 auto;
  }
`;

export const ClinicSectionChild = styled.div``;

export const FormContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const Grid = styled.div`
  width: ${(props: { fullWidth: boolean }) =>
    props.fullWidth ? "100%" : "50%"};
`;
